<template>
    <Box title="维修派工">
        <van-tabs
            swipeable
            background="rgba(0,0,0,0)"
            line-width="20px"
            v-model="tabsIndex"
            @click="propconfirm"
        >
            <van-tab :title="'未派工('+TotalNotDispatch+'台)'">
                <div class="tagsBox">
                    <LoadingFooter
                        v-model="NotDispatch.loading"
                        :finished="NotDispatch.finished"
                        @load="onLoad_NotDispatch"
                    >
                        <div class="commonItems" v-for="item in NotDispatchList" @click="$router.push({name: 'Dispatch', params: {item}})">
                            <div>
                                <img src="@/assets/img/Icon_1.png"/>
                                <div>
                                    <p class="ellipsis">{{item.EquName}}</p>
                                    <div>
                                        <div>
                                            <p>资产编号：</p>
                                            <p>规格型号：</p>
                                            <p>使用科室：</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquCode}}</p>
                                            <p class="ellipsis">{{item.Size}}</p>
                                            <p class="ellipsis">{{item.DepartmentName}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>去派工</div>
                                </div>
                            </div>
                            <div>
                                <span>启用日期</span>
                                <span>{{item.EnableDate}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
            <van-tab :title="'已派工('+TotalDispatch+'台)'">
                <div class="tagsBox">
                    <LoadingFooter
                        v-model="Dispatch.loading"
                        :finished="Dispatch.finished"
                        @load="onLoad_Dispatch"
                    >
                        <div class="commonItems" v-for="item in DispatchList">
                            <div>
                                <img src="@/assets/img/Icon_1.png"/>
                                <div>
                                    <p class="ellipsis">{{item.EquName}}</p>
                                    <div>
                                        <div>
                                            <p>资产编号：</p>
                                            <p>规格型号：</p>
                                            <p>报修科室：</p>
                                            <p>报修人员</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquCode}}</p>
                                            <p class="ellipsis">{{item.Size}}</p>
                                            <p class="ellipsis">{{item.DepartmentName}}</p>
                                            <p class="ellipsis">{{item.RepairPeople}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                            <div>
                                <span>启用日期</span>
                                <span>{{item.EnableDate}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
        </van-tabs>
    </Box>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import {Tab, Tabs} from 'vant'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'DispatchList',
        components: {
            Box,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        data() {
            return {
                tabsIndex: 0,
                IsSee:false,
                NotDispatch: {//未派工页面状态
                    loading: true,
                    finished: false
                },
                Dispatch: {//已派工页面状态
                    loading: true,
                    finished: false
                },
                NotDispatchList:[],//未派工
                TotalNotDispatch:0,//未派工数量
                DispatchList:[],//已派工
                TotalDispatch:0,//已派工数量
                page:5,
                pageHas:5,
            }
        },
        activated(){
            this.loadDataDefaultNotDispatch();
        },
        methods: {
            onLoad_NotDispatch() {//未派工选项卡
               if (!this.NotDispatch.loading && !this.NotDispatch.finished) {
                   this.page += 5;
                   this.loadDataDefaultNotDispatch();
               }
            },
            onLoad_Dispatch() {//已派工选项卡
                if (!this.Dispatch.loading && !this.Dispatch.finished) {
                    this.pageHas += 5;
                    this.loadDataDefaultDispatch();
                }
            },propconfirm(){//选项卡点击事件
               this.tabsIndex===0?this.loadDataDefaultNotDispatch():this.loadDataDefaultDispatch();
            },loadDataDefaultNotDispatch(){//加载为未派工数据
               this.$post('api/Dispatch/DispatchList',{
                   RepairStatus:'1',
                   EquCode:'',
                   RepairOrder:'',
                   DepartmentId:'',
                   UserCode:this.$UserInfo.UserId,
                   Store:this.$UserInfo.StoreCode,
                   SortType:'',
                   AssignOrConfirm:'1',
                   StartDate:'',
                   EndDate:'',
                   PageIndex:1,
                   PageSize:this.page,
                   Token:'123456'
               }).then(result=>{
                   this.TotalNotDispatch=result.Total;
                   this.NotDispatchList=result.DispatchList;
                   if (this.page >= result.Total) {
                       this.NotDispatch.loading = false;
                       this.NotDispatch.finished = true;
                   }else this.NotDispatch.loading=false;
               })
            },loadDataDefaultDispatch(){//已派工列表查询
                this.$post('api/Dispatch/DispatchList',{
                    RepairStatus:'6',
                    EquCode:'',
                    RepairOrder:'',
                    DepartmentId:'',
                    UserCode:this.$UserInfo.UserId,
                    Store:this.$UserInfo.StoreCode,
                    SortType:'',
                    AssignOrConfirm:'1',
                    StartDate:'',
                    EndDate:'',
                    PageIndex:1,
                    PageSize:this.pageHas,
                    Token:'123456'
                }).then(result=>{
                    this.TotalDispatch=result.Total;
                    this.DispatchList=result.DispatchList;
                    if (this.pageHas >=result.Total) {
                        this.Dispatch.loading = false;
                        this.Dispatch.finished = true;
                    }else this.Dispatch.loading=false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .tagsBox{
        margin-top: 160px;
    }
</style>



// WEBPACK FOOTER //
// src/page/dispatchList/dispatchList.vue